import React from 'react';

import ApiClientsListItem from './ApiClientsListItem';

export default function ApiClientsList(props) {
    return (
        <div className="tw-grid tw-grid-cols-4 tw-gap-4">
            {props.apps.map((item) => {
                return <ApiClientsListItem key={item.id} item={item} />;
            })}
        </div>
    );
}
